/**
 * Runtime configuration injected into the page at deploy time via `app-config.js`.
 *
 * The CDK BucketDeployment writes a JS file that sets `window.__OBD_DASHBOARD_CONFIG__`
 * with environment-specific values (API URL, Cognito client ID, etc.). Mirrors the
 * same pattern Otto uses — keeps the React build artefact env-agnostic so the same
 * bundle can be deployed to staging and production with only the config file differing.
 *
 * When running locally with `vite dev` (no app-config.js present), falls back to dev
 * defaults that allow you to develop UI offline without a real Cognito user pool.
 */
export interface DashboardConfig {
  environment: string;
  buildCommit: string;
  apiBaseUrl: string;
  auth: {
    cognitoHostedUiBaseUrl: string;
    clientId: string;
    identityProvider: string;
    responseType: string;
    scope: string;
  };
}

declare global {
  interface Window {
    __OBD_DASHBOARD_CONFIG__?: DashboardConfig;
  }
}

export function getConfig(): DashboardConfig {
  const config = window.__OBD_DASHBOARD_CONFIG__;
  if (config) return config;
  return {
    environment: 'local',
    buildCommit: 'local',
    apiBaseUrl: '',
    auth: {
      cognitoHostedUiBaseUrl: '',
      clientId: 'local-client-id',
      identityProvider: 'DRIVE-INC-STAFF-LOGIN',
      responseType: 'code',
      scope: 'openid email profile',
    },
  };
}
